"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bgCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var bgCountry = exports.bgCountry = function bgCountry(t) {
  return {
    id: 'BG',
    name: t('Bulgaria'),
    flag: '🇧🇬',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{4}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1000 or 4000',
    phonePrefix: '359',
    phoneLength: 9,
    pricingVersion: 14,
    currency: 'EUR',
    timezone: 'Europe/Sofia'
  };
};